module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2NIJ4"))).then(() => parcelRequire('9Lwss'));